import { useParams } from "react-router-dom";

import { getPublicMention } from "@/api/endpoints/mentions";
import Episode from "@/containers/Episode";
import Episodes from "@/containers/Episodes";
import useSearchParams from "@/hooks/useSearchParams";
import SharedLinkLayout from "@components/SharedLinkLayout";
import Typography from "@components/Typography";
import { useQuery } from "@tanstack/react-query";

import styles from "./PublicSingleMentionView.module.css";

const PublicSingleMentionView = () => {
  const { uuid, language } = useParams<{ uuid: string; language: string }>();
  const [{ kpis, sentiment }] = useSearchParams<{
    kpis: boolean;
    sentiment: boolean;
  }>();

  const hideKpis = kpis === false;
  const hideSentiment = sentiment === false;

  const { data } = useQuery({
    queryKey: ["publicMention", uuid, language],
    queryFn: () => getPublicMention(uuid, language),
  });

  if (!data?.ok) return null;
  const publicMention = data.data;

  const episodes = publicMention?.object_list;
  const { is_report, initial_post_processing } = {
    is_report: publicMention?.is_report,
    initial_post_processing: publicMention?.initial_post_processing,
  };

  return (
    <SharedLinkLayout>
      <header className={styles.header}>
        <Typography className={styles.title} variant="h1">
          {publicMention?.report_title}
        </Typography>
        <Typography className={styles.subtitle} variant="subtitle-1">
          {L.PUBLIC_MENTION_SUBTITLE}
        </Typography>
      </header>
      <Episodes>
        {episodes?.map((ep) => (
          <Episode
            {...ep}
            {...ep?.post_data}
            key={ep.episode_uuid}
            hideReach={hideKpis}
            hidePrValue={hideKpis}
            hideSentiment={hideSentiment}
            hideMetadata={hideKpis}
            hideTags
            hideActions
            searchIsProcessing={initial_post_processing}
            is_report={is_report}
          />
        ))}
      </Episodes>
    </SharedLinkLayout>
  );
};

export default PublicSingleMentionView;
